/** Closing call to action on the tool's own gradient, linking back to the studio. */
export function ToolCta({
  swatch,
  title,
  description,
  actionLabel,
  actionHref,
  onAction,
}: {
  onAction?: () => void;
  swatch: string;
  title: string;
  description: string;
  actionLabel: string;
  actionHref: string;
}) {
  return (
    <section className="relative overflow-hidden rounded-2xl px-6 py-14 text-center text-white sm:py-20" style={{ background: swatch }}>
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-black/0" aria-hidden="true" />
      <div className="relative mx-auto max-w-xl space-y-4">
        <h2 className="text-balance text-3xl font-black tracking-tight sm:text-4xl">{title}</h2>
        <p className="text-pretty text-base leading-7 text-white/85">{description}</p>
        <div className="pt-3">
          <a
            href={actionHref}
            onClick={onAction}
            className="inline-flex h-12 items-center rounded-full bg-white px-7 text-sm font-semibold text-neutral-900 shadow-sm transition-transform hover:-translate-y-0.5"
          >
            {actionLabel}
          </a>
        </div>
      </div>
    </section>
  );
}
